module.exports = __webpack_public_path__ + "img/google-business.adcffc82.svg";